import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: #fff;
	padding: 0 65px;

	& > div {
		margin: 0 auto;
		width: 100%;
		max-width: 1235px;
	}
`;

export const Content = styled.div<{ loading?: boolean }>`
	grid-template-columns: 445px 1fr;
	display: ${({ loading }) => (loading ? 'none' : 'grid')};
`;

export const Footer = styled.div`
	margin: 25px auto;
	width: 100%;
	max-width: 1235px;
	display: flex;
	justify-content: flex-end;
	gap: 33px;
`;
